module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/_library.js
// module id = 31
// module chunks = 36